import { find } from "lodash";
import Images from "../components/Images";

export default function getImage(imageName: string) {
  var img = find(Images, { id: imageName });
  return img ? img.img : "";
}
